type PaymentOption = {
  provider: string
}

export function isDepositPaymentOption({provider}: PaymentOption): boolean {
  return provider === 'enovipayCoinspaid'
}
